const intersectionObserverMagic = () => {
    const faders = document.querySelectorAll(".csp-fade-in");
    const sliders = document.querySelectorAll(".csp-slide-in");
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    let root = "0px 0px -50px 0px";
    if (vw > 1024){
        root = "0px 0px -100px 0px";
    }
    const appearOptions = {
        threshold: 0,
        rootMargin: root
    };

    const appearOnScroll = new IntersectionObserver(function(
            entries,
            appearOnScroll
        ) {
            entries.forEach(entry => {
                if (!entry.isIntersecting) {
                    return;
                } else {
                    entry.target.classList.add("appear");
                    appearOnScroll.unobserve(entry.target);
                }
            });
        },
        appearOptions);

    faders.forEach(fader => {
        appearOnScroll.observe(fader);
    });
    sliders.forEach(slider => {
        appearOnScroll.observe(slider);
    });
}

export default intersectionObserverMagic;